import gql from "graphql-tag";

export default {
update: gql`
    mutation UpdateHtmlCell ($input: UpdateHtmlCellInput!) {
        updateHtmlCell (input: $input) {
            id
            html

        }
    }`,

get: gql`
    query HtmlCell($id: ID!) {
        htmlCell(id: $id) {
            id
            html
        }
    }`
}
